<template>
  <div class="content">
    <div class="container">
      <div class="agb">
        <header-logo :logo-url="globalLogoUrl" />
        <h1 v-word:layout.agb.header />
        <h2 v-word:layout.agb.subheader />
        <div v-word:layout.agb.text />
      </div>
      <div class="form__section__links form__section__links--back policy-links">
        <a class="button"
           :href="!editMode && backUrl"
           v-word:layout.agb.link.back />
      </div>
    </div>
  </div>
</template>

<script>
import * as mixins from '../mixins';

export default {
  props: ['editMode'],
  mixins: [mixins.wordedPage, mixins.pageWithLogo, mixins.backUrl],
};
</script>



// WEBPACK FOOTER //
// src/pages/Agb.vue